import './style';
import App from './components/app';

// Dev config
// let config = {
//   apiKey: "AIzaSyDRvAAc4zvCor3gFZgCFJYfjSYi_dVrsU4",
//   authDomain: "restaurant-franchise-mgmt.firebaseapp.com",
//   databaseURL: "https://restaurant-franchise-mgmt.firebaseio.com",
//   projectId: "restaurant-franchise-mgmt",
//   storageBucket: "restaurant-franchise-mgmt.appspot.com",
//   messagingSenderId: "879321224845"
// };
// Production config
let config = {
  apiKey: "AIzaSyDkADBKp_yEVnLEUnDLWVOw-YVzJirHUlQ",
  authDomain: "fast-pos.firebaseapp.com",
  databaseURL: "https://fast-pos.firebaseio.com",
  projectId: "fast-pos",
  storageBucket: "fast-pos.appspot.com",
  messagingSenderId: "545630531831"
};
if (typeof window !== 'undefined') {
  window.firebase && window.firebase.initializeApp(config);
}

export default App;



// WEBPACK FOOTER //
// ./index.js